import MetadataRemote from "@/metadata.js";

let metadataRemote = new MetadataRemote();

// Cache for species data to avoid multiple API calls
let speciesCache = null;
let loadingPromise = null;

/**
 * Fetch species data from API with caching
 * @returns {Promise<Array>} Array of species objects with value, label, and icon
 */
function getSpeciesFromMetadataAPI() {
    // Return cached data if available
    if (speciesCache) {
        return speciesCache;
    }

    // If already loading, return the existing promise
    if (loadingPromise) {
        return loadingPromise;
    }

    // Start loading
    loadingPromise = metadataRemote.getSpecies()
        .then((data) => {
            speciesCache = data.attributes.species;
            loadingPromise = null;
            return speciesCache;
        });

    return loadingPromise;
}

async function getSpeciesImage(species) {
    let speciesList = await getSpeciesFromMetadataAPI();
    let found = speciesList.find((s) => s.value === species);

    return found ? found.path : 'help';
}

function imageLayoutFor(n, width = 420, height = 420) {
    // Get center coordinates of image space
    const cx = width / 2;
    const cy = height / 2;

    // 1 Image: centered
    if (n <= 1) {
        return [{ x: cx, y: cy, r: 200 }];
    }

    // 2 Images: diagonal pair
    if (n === 2) {
        const dx = 80, dy = 80, r = 125;
        return [
        { x: cx - dx, y: cy - dy, r: r },
        { x: cx + dx, y: cy + dy, r: r }
        ];
    }

    // 3 Images: triangle (one on top, two bottom)
    if (n === 3) {
        const topY = cy - 80;
        const botY = cy + 80;
        const dx = 90;
        const r = 110;
        return [
        { x: cx,      y: topY, r: r },
        { x: cx - dx, y: botY, r: r },
        { x: cx + dx, y: botY, r: r }
        ];
    }

    // 4+ Images: 2x2 cluster
    const dx = 80, dy = 80, r = 90;
    return [
        { x: cx - dx, y: cy - dy, r: r },
        { x: cx + dx, y: cy - dy, r: r },
        { x: cx - dx, y: cy + dy, r: r },
        { x: cx + dx, y: cy + dy, r: r }
    ];
}

export { getSpeciesImage, imageLayoutFor };
